export const captionsIcon = (
    <svg
        className="captions"
        aria-label="Close captions available"
        height="10"
        width="11.25"
        viewBox="0 0 11.25 10"
    >
        <path d="m 10,0 c 0.6875,0 1.25,0.5625 1.25,1.25 v 7.5 C 11.25,9.4375 10.6875,10 10,10 H 1.25 C 0.55625,10 0,9.4375 0,8.75 V 1.25 C 0,0.5625 0.55625,0 1.25,0 Z M 5,4.375 V 3.75 C 5,3.40625 4.71875,3.125 4.375,3.125 H 2.5 c -0.34375,0 -0.625,0.28125 -0.625,0.625 v 2.5 c 0,0.34375 0.28125,0.625 0.625,0.625 H 4.375 C 4.71875,6.875 5,6.59375 5,6.25 V 5.625 H 4.0625 v 0.3125 h -1.25 v -1.875 h 1.25 V 4.375 Z m 4.375,0 V 3.75 C 9.375,3.40625 9.09375,3.125 8.75,3.125 H 6.875 C 6.53125,3.125 6.25,3.40625 6.25,3.75 v 2.5 c 0,0.34375 0.28125,0.625 0.625,0.625 H 8.75 c 0.34375,0 0.625,-0.28125 0.625,-0.625 V 5.625 H 8.4375 v 0.3125 h -1.25 v -1.875 h 1.25 V 4.375 Z" />
    </svg>
);
